import $ from 'jquery';

$(function() {

    async function initMap() {

        // Request needed libraries.
        const { Map, StreetViewPanorama } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
        const map_el = $('#map');
        let markersArray = [];
        let markerCluster = null;
        let fitBoundsInit = false; 

        const map = new google.maps.Map(document.getElementById("map"), {
            tilt: 0,
            heading: 0,
            zoom: 3,
            center: { lat: -28.024, lng: 140.887 },
            mapId: map_el.data('mapid'),
        });

        // Enable WebGL rendering if available
        map.setOptions({ 
            webgl: true,
            tilt: 45
        });

        // Initialize Street View Panorama
        const panorama = new google.maps.StreetViewPanorama(
            document.getElementById("street-view"),
            {
                position: { lat: -28.024, lng: 140.887 },
                pov: {
                    heading: 34,
                    pitch: 10,
                },
                visible: false,
            }
        );


        // Safely parse markers data
        let markersData = $('#filter-form').data('markers');
        try {
            //markersData = JSON.parse(markersData);
            if (!Array.isArray(markersData)) {
                console.error("markersData is not an array:", markersData);
                markersData = [];
            }
        } catch (e) {
            console.error("Error parsing markersData:", e);
        }

        // Add markers to the map
        //createMarkers(markersData);

        function showPropertyCard(marker) {
            var propertyCard = $(".map-sidebar .property-card");
            if (propertyCard.length) {
                propertyCard.find('.property-img').attr('src', marker.img + '?t=' + Date.now());
                propertyCard.find('.property-title').html(marker.title || '[TITLE]');
                propertyCard.find('.property-price').html(marker.price || '[PRICE]');
                propertyCard.find('.property-beds').html(marker.beds || '[BEDS]');
                propertyCard.find('.property-link').attr('data-propertyid', marker.id || '');
                propertyCard.find('.property-link').attr('data-propertyname', marker.title || '');
                $(".development-map-section").addClass("show-sidebar");

                propertyCard.find('.property-streetview-btn').off('click').on('click', function(e) {
                    e.preventDefault();
                    showStreetView(marker);
                });

                propertyCard.find('.property-streetview-hide-btn').off('click').on('click', function(e) {
                    e.preventDefault();
                    hideStreetView();
                })

            }
        }

        function hidePropertyCard() {
            $(".development-map-section").removeClass("show-sidebar");
        }

        function showStreetView(position) {
            const panorama = new google.maps.StreetViewPanorama(
                document.getElementById("street-view"),
                {
                    position: { lat: position.lat, lng: position.lng },
                    pov: {
                        heading: 34,
                        pitch: 10,
                    },
                    visible: true,
                }
            );
            $('.development-map-section').addClass('show-street-view');
        }

        function hideStreetView() {
            panorama.setVisible(false);
            $('.development-map-section').removeClass('show-street-view');
        }

        function classMapSidebar() {
            var mapSidebar = $(".map-sidebar");
            if (mapSidebar.length) {
                mapSidebar.find('.close').on('click', function() {
                    hidePropertyCard();
                    hideStreetView();
                });
            }
        }

        function mapFilter() {
    
            var mapFilter = $('.map-filter');
    
            if(mapFilter.length) {
                
                mapFilter.find('.filter-item').each(function() {
                    var filterItem = $(this);
    
                    // toggle dropdown options
                    filterItem.find('.filter-btn').on('click', function() {
                        filterItem.toggleClass('open');
                    });
    
                    // call ajax filter form when checkbox is clicked
                    filterItem.find('input[type="checkbox"]').on('change', function() {
                        ajaxMapFilter();
                    });
                });
                
            }
    
            function ajaxMapFilter() {
                var form = $('#filter-form');
                var mapSection = $('.development-map-section');
                var formData = form.serialize();
    
                mapSection.addClass('loading');
    
                $.ajax({
                    url: form.data('action'),
                    type: 'POST',
                    data: formData,
                    dataType: 'json',
                    success: function(response) {
                        if (response.status === 'success') {
                            var markersData = response.markers;

                            // Clear existing markers before adding new ones
                            removeMarkers();

                            // Create new markers
                            createMarkers(markersData);
                        }
                    },
                    complete: function() {
                        mapSection.removeClass('loading');
                    }
                });

            }

            // Initialize the filter to load markers by default
            setTimeout(function() {
                ajaxMapFilter();
            }, 1000);
        }

        function createMarkers(markersData) {

            if (!map) {
                console.error("Map is not initialized");
                return;
            }

            // Add markers to the map
            markersArray = markersData.map((position, i) => {
                if (!position.lat || !position.lng || isNaN(position.lat) || isNaN(position.lng)) {
                    console.warn("Invalid position data for marker:", position);
                    return null;
                }

                const customMarkerImg = document.createElement("img");
                const markerIconUrl = map_el.data('markericon');
                if (!markerIconUrl) {
                    console.warn("Marker icon URL is missing");
                    return null;
                }
                customMarkerImg.src = markerIconUrl;
                customMarkerImg.style.width = "45px";
                customMarkerImg.style.height = "45px";
                customMarkerImg.onerror = () => console.error("Failed to load marker image:", markerIconUrl);

                const marker = new google.maps.marker.AdvancedMarkerElement({
                    map: map,
                    position: { lat: Number(position.lat), lng: Number(position.lng) },
                    content: customMarkerImg,
                    title: position.title || "Property",
                });

                marker.addListener("click", () => {
                    hidePropertyCard();
                    setTimeout(() => {
                        showPropertyCard(position);
                        //showStreetView(position);
                    }, 300);
                });

                return marker;
            }).filter(marker => marker !== null);

            // Create bounds and extend for each marker
            const bounds = new google.maps.LatLngBounds();
            markersArray.forEach((marker) => {
                bounds.extend(marker.position);
            });

            // Add marker clusterer
            markerCluster = new markerClusterer.MarkerClusterer({
                markers: markersArray,
                map,
                renderer: {
                    render: ({ count, position }) => {
                        return new google.maps.Marker({
                            position,
                            icon: {
                                path: google.maps.SymbolPath.CIRCLE,
                                fillColor: "black",
                                fillOpacity: 0.8,
                                strokeWeight: 0,
                                scale: 20,
                            },
                            label: {
                                text: String(count),
                                color: "white",
                                fontSize: "14px",
                                fontWeight: "normal",
                            },
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                        });
                    },
                },
            });

            if (markersArray.length > 0 && !fitBoundsInit) {
                map.fitBounds(bounds);
                fitBoundsInit = true; // Only fit bounds once
            } else {
                console.warn("No valid markers to display");
            }
        }

        function removeMarkers() {
            
            for (let i = 0; i < markersArray.length; i++) {
                markersArray[i].setMap(null);

                if (markerCluster && typeof markerCluster.removeMarker === 'function') {
                    markerCluster.removeMarker(markersArray[i]); // Remove from MarkerClusterer
                }
            }

            markersArray = [];
        }


        classMapSidebar();
        mapFilter();


    }

    function stickyMapCTA(){

        var target = $('.map-sticky-btn');

        if(target.length){
            target.on('click', function(e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $( '.development-map-section' ).offset().top
                }, 2000);
            });
        }
    }


    //-------------------------------------------------


    initMap();
    stickyMapCTA();

});